const checkReturnType = (result) => {
  if (!result || !(result instanceof Array) || result.length < 2) {
    console.error(
      "Return value supplied by processing hook is not array with two elements. It is: ",
      JSON.stringify(result, null, 2)
    );
  }
  return result;
};
const _chainHooks = (hooks, args) => hooks.reduce(
  (prev, cur) => prev.then(checkReturnType).then(([newView, newExecutionState]) => cur({ ...args, view: newView, executionState: newExecutionState })),
  Promise.resolve([args.view, args.executionState])
);
const _processViewHooks = (viewHooks, view, query, executionState, onSuccess) => {
  let promise;
  if (viewHooks.length > 0) {
    const retry = (args) => {
      var _a, _b;
      const _view = (_a = args.view) != null ? _a : view;
      const _executionState = (_b = args.executionState) != null ? _b : executionState;
      return _processViewHooks(viewHooks, _view, query, _executionState, onSuccess);
    };
    promise = _chainHooks(viewHooks, { view, retry, query, executionState });
  } else {
    promise = Promise.resolve([view, executionState]);
  }
  return promise.then(checkReturnType).then(async ([newView, newExecutionState]) => {
    await onSuccess(newView, newExecutionState);
    return [newView, newExecutionState];
  });
};
const processHooks = (promise, executionState, loadingViewHooks = [], executingViewHooks = [], query = {}, onSuccess = () => {
}) => promise.then((view) => _processViewHooks(loadingViewHooks, view, query, executionState, onSuccess)).then(
  ([newView, newExecutionState]) => _processViewHooks(executingViewHooks, newView, query, newExecutionState, onSuccess)
);
export default processHooks;
